import { useQuery, useMutation, useQueryClient } from 'react-query';
import api from '../services/api';

export const useNotifications = (options = {}) => {
  return useQuery(
    ['notifications', options],
    () => api.getNotifications(options),
    {
      enabled: false, // Disable automatic fetching
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      staleTime: Infinity, // Never auto-refetch
      cacheTime: 5 * 60 * 1000, // Keep in cache for 5 minutes
      ...options,
    }
  );
};

export const useMarkNotificationRead = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (id) => api.markNotificationRead(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('notifications');
      },
    }
  );
};

export const useMarkAllNotificationsRead = () => {
  const queryClient = useQueryClient();
  return useMutation(
    () => api.markAllNotificationsRead(),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('notifications');
      },
    }
  );
};
